import React from 'react';
import { useTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';

import useDevicesPageLogic from './hooks/useDevicesPageLogic';
import Layout from '@components/layout';
import PageTitle from '@components/snippets/PageTitle';
import AddDeviceModal from './AddDeviceModal';
import DevicesFilter from './DevicesFilter';
import DevicesList from './DevicesList';
import Empty from '@components/snippets/Empty';

function DevicesPage(props) {
  const {
    filters,
    pin,
    setPin,
    device,
    showForm,
    loading,
    toggle,
    devices,
    calendars,
    deviceScreenshot,
    sort,
    logs,
    onLogsRequest,
    onCreate,
    createLoading,
    onFetchDevice,
    onDeleteDevice,
    onEdit,
    onDeactivate,
    onGetScreenshot,
    onFilter,
    onSearch,
    onSort,
    onFetchScreenshot,
    onFetchLogs,
  } = useDevicesPageLogic();
  const { t } = useTranslation();

  return (
    <div className="devices-page">
      <div className="devices-page__header">
        <PageTitle
          title={t('devices')}
          extra={
            <AddDeviceModal
              t={t}
              loading={createLoading}
              pin={pin}
              setPin={setPin}
              showForm={showForm}
              toggle={toggle}
              calendars={calendars}
              onFinish={onCreate}
            />
          }
        />
        <DevicesFilter
          t={t}
          filters={filters}
          sort={sort}
          onFilter={onFilter}
          onSearch={onSearch}
          onSort={onSort}
        />
      </div>
      <DevicesList
        t={t}
        logs={logs}
        onLogsRequest={onLogsRequest}
        onFetchLogs={onFetchLogs}
        onFetchScreenshot={onFetchScreenshot}
        device={device}
        loading={loading}
        devices={devices}
        calendars={calendars}
        screenshot={deviceScreenshot}
        onFetchDevice={onFetchDevice}
        onDeleteDevice={onDeleteDevice}
        onEdit={onEdit}
        onDeactivate={onDeactivate}
        onGetScreenshot={onGetScreenshot}
      />
    </div>
  );
}

export default DevicesPage;
